// extracted by mini-css-extract-plugin
export default {"melodyVideo":"OK-z","isFullWidth":"PK-z","landingPageVideo":"QK-z","play":"RK-z","iframeVideo":"SK-z","playHidden":"TK-z","fullwidth":"UK-z"};